/* Futurespin Produktvergleich
   - Sammelt Produkte pro Kategorie (belag / holz) in localStorage
   - Zeigt eine sticky Vergleichsleiste
   - Öffnet ein Overlay mit Vergleichstabelle
   Werte aus Metafeldern custom.*, normiert: 150 = voller Balken.
*/
(function () {
  "use strict";

  var STORE_KEY = "futurespinCompare_v1";
  var MAX_ITEMS = 3;
  var NORM_FULL = 150;

  var CATS = {
    belag: { label: "Beläge", labelOne: "Belag" },
    holz:  { label: "Hölzer", labelOne: "Holz" }
  };

  function load() {
    try {
      var raw = localStorage.getItem(STORE_KEY);
      if (!raw) return { belag: [], holz: [] };
      var obj = JSON.parse(raw);
      if (!obj || typeof obj !== "object") return { belag: [], holz: [] };
      if (!Array.isArray(obj.belag)) obj.belag = [];
      if (!Array.isArray(obj.holz)) obj.holz = [];
      return obj;
    } catch (e) { return { belag: [], holz: [] }; }
  }
  function save(state) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {}
  }

  function pct(v) {
    if (v === null || v === undefined || v === "" || isNaN(v)) return null;
    var p = Math.round((Number(v) / NORM_FULL) * 100);
    if (p < 0) p = 0; if (p > 100) p = 100;
    return p;
  }
  function dash(v) {
    return (v === null || v === undefined || v === "") ? "–" : v;
  }
  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  var state = load();

  function countTotal() { return state.belag.length + state.holz.length; }

  function inList(cat, handle) {
    return state[cat].some(function (p) { return p.handle === handle; });
  }

  function addItem(cat, item) {
    if (!CATS[cat]) return { ok: false, msg: "Unbekannte Kategorie." };
    if (inList(cat, item.handle)) return { ok: false, msg: "Schon im Vergleich." };
    if (state[cat].length >= MAX_ITEMS) {
      return { ok: false, msg: "Maximal " + MAX_ITEMS + " " + CATS[cat].label + " vergleichbar." };
    }
    state[cat].push(item);
    save(state);
    render();
    if (state[cat].length === 2) {
      setTimeout(function () { openOverlay(cat); }, 250);
    }
    return { ok: true };
  }

  function removeItem(cat, handle) {
    state[cat] = state[cat].filter(function (p) { return p.handle !== handle; });
    save(state);
    render();
  }

  function clearCat(cat) { state[cat] = []; save(state); render(); }

  function readProductFromDom() {
    var el = document.getElementById("fs-compare-data");
    if (!el) return null;
    var d = el.dataset;
    if (!d.handle || !d.cat) return null;
    if (!CATS[d.cat]) return null;
    return {
      handle: d.handle,
      cat: d.cat,
      title: d.title || "",
      url: d.url || ("/products/" + d.handle),
      image: d.image || "",
      price: d.price || "",
      tempo: d.tempo || "",
      kontrolle: d.kontrolle || "",
      elastizitaet: d.elast || "",
      haerte: d.haerte || "",
      schwammhaerte: d.schwammhaerte || "",
      schwamm: d.schwamm || "",
      holztyp: d.holztyp || "",
      eignung: d.eignung || "",
      gewicht: d.gewicht || ""
    };
  }

  function syncToggleButton() {
    var btn = document.getElementById("fs-compare-toggle");
    var prod = readProductFromDom();
    if (!btn || !prod) return;
    if (inList(prod.cat, prod.handle)) {
      btn.classList.add("is-added");
      btn.querySelector(".fs-ct-label").textContent = "Im Vergleich ✓";
    } else {
      btn.classList.remove("is-added");
      btn.querySelector(".fs-ct-label").textContent = "Zum Vergleich hinzufügen";
    }
  }

  function buildBar() {
    var bar = document.getElementById("fs-compare-bar");
    if (!bar) {
      bar = document.createElement("div");
      bar.id = "fs-compare-bar";
      bar.className = "fs-compare-bar";
      document.body.appendChild(bar);
    }
    return bar;
  }

  function buildFab() {
    var fab = document.getElementById("fs-compare-fab");
    if (!fab) {
      fab = document.createElement("button");
      fab.type = "button";
      fab.id = "fs-compare-fab";
      fab.className = "fs-compare-fab";
      document.body.appendChild(fab);
      fab.addEventListener("click", function () {
        var b = state.belag.length, h = state.holz.length;
        if (b === 0 && h === 0) return;
        var cat = (b >= h) ? "belag" : "holz";
        if (state[cat].length === 0) cat = (cat === "belag") ? "holz" : "belag";
        openOverlay(cat);
      });
    }
    return fab;
  }

  function render() {
    syncToggleButton();
    syncCardButtons();
    var bar = buildBar();
    var fab = buildFab();
    var total = countTotal();
    if (total === 0) {
      bar.classList.remove("is-visible");
      bar.innerHTML = "";
      fab.classList.remove("is-visible");
      return;
    }
    var fabLabel = "Vergleichen";
    fab.innerHTML = '<span class="fs-fab-icon">\u21c4</span> ' + fabLabel +
      ' <span class="fs-fab-count">' + total + '</span>';
    fab.classList.add("is-visible");

    var parts = [];
    parts.push('<div class="fs-bar-inner">');
    parts.push('<div class="fs-bar-cats">');
    ["belag", "holz"].forEach(function (cat) {
      var n = state[cat].length;
      if (n === 0) return;
      var lbl = n === 1 ? CATS[cat].labelOne : CATS[cat].label;
      parts.push('<div class="fs-bar-cat">');
      parts.push('<span class="fs-bar-count">' + n + '</span> ' + esc(lbl));
      parts.push('<button type="button" class="fs-bar-compare" data-cat="' + cat + '">Vergleichen</button>');
      parts.push('<button type="button" class="fs-bar-clear" data-cat="' + cat + '" title="Leeren">✕</button>');
      parts.push('</div>');
    });
    parts.push('</div>');
    parts.push('</div>');
    bar.innerHTML = parts.join("");
    bar.classList.add("is-visible");

    bar.querySelectorAll(".fs-bar-compare").forEach(function (b) {
      b.addEventListener("click", function () { openOverlay(this.dataset.cat); });
    });
    bar.querySelectorAll(".fs-bar-clear").forEach(function (b) {
      b.addEventListener("click", function () { clearCat(this.dataset.cat); });
    });
  }

  function barRow(label, items, key) {
    var cells = items.map(function (p) {
      var p100 = pct(p[key]);
      if (p100 === null) return '<td class="fs-cell"><span class="fs-na">–</span></td>';
      return '<td class="fs-cell"><div class="fs-bar-bg"><div class="fs-bar-fill" style="width:' +
        p100 + '%"></div></div><span class="fs-bar-val">' + p100 + '</span></td>';
    }).join("");
    return '<tr><th class="fs-rowlabel">' + esc(label) + '</th>' + cells + '</tr>';
  }
  function textRow(label, items, key, suffix) {
    var cells = items.map(function (p) {
      return '<td class="fs-cell">' + esc(dash(p[key])) + (p[key] ? (suffix || "") : "") + '</td>';
    }).join("");
    return '<tr><th class="fs-rowlabel">' + esc(label) + '</th>' + cells + '</tr>';
  }

  function openOverlay(cat) {
    var items = state[cat];
    if (!items || items.length === 0) return;

    var ov = document.getElementById("fs-compare-overlay");
    if (!ov) {
      ov = document.createElement("div");
      ov.id = "fs-compare-overlay";
      ov.className = "fs-compare-overlay";
      document.body.appendChild(ov);
    }

    var head = items.map(function (p) {
      return '<th class="fs-prodhead">' +
        (p.image ? '<img src="' + esc(p.image) + '" alt="" class="fs-prodimg">' : '') +
        '<a href="' + esc(p.url) + '" class="fs-prodtitle">' + esc(p.title) + '</a>' +
        '<button type="button" class="fs-prodremove" data-cat="' + cat + '" data-handle="' +
        esc(p.handle) + '">Entfernen</button>' +
        '</th>';
    }).join("");

    var rows = [];
    rows.push(barRow("Tempo", items, "tempo"));
    rows.push(barRow("Kontrolle", items, "kontrolle"));
    rows.push(barRow("Elastizität", items, "elastizitaet"));
    rows.push(textRow("Härte", items, "haerte"));
    if (cat === "holz") rows.push(textRow("Gewicht", items, "gewicht", " g"));
    if (cat === "belag") rows.push(textRow("Schwammhärte", items, "schwammhaerte"));
    if (cat === "belag") rows.push(textRow("Schwammstärke", items, "schwamm"));
    if (cat === "holz") rows.push(textRow("Holz-Typ", items, "holztyp"));
    rows.push(textRow("Preis", items, "price"));
    rows.push(textRow("Eignung", items, "eignung"));

    var catLbl = CATS[cat] ? CATS[cat].label : "";
    ov.innerHTML =
      '<div class="fs-ov-backdrop"></div>' +
      '<div class="fs-ov-panel" role="dialog" aria-modal="true" aria-label="Produktvergleich">' +
        '<div class="fs-ov-head">' +
          '<div class="fs-ov-title">' + esc(catLbl) + ' im Vergleich</div>' +
          '<button type="button" class="fs-ov-close" aria-label="Schließen">✕</button>' +
        '</div>' +
        '<div class="fs-ov-scroll">' +
          '<table class="fs-table"><thead><tr><th class="fs-corner"></th>' + head + '</tr></thead>' +
          '<tbody>' + rows.join("") + '</tbody></table>' +
          '<div class="fs-ov-note">Werte sind ca.-Angaben zur Orientierung. Balken: 0–100 (normiert).</div>' +
        '</div>' +
      '</div>';
    ov.classList.add("is-open");
    document.body.style.overflow = "hidden";

    function close() {
      ov.classList.remove("is-open");
      document.body.style.overflow = "";
    }
    ov.querySelector(".fs-ov-close").addEventListener("click", close);
    ov.querySelector(".fs-ov-backdrop").addEventListener("click", close);
    ov.querySelectorAll(".fs-prodremove").forEach(function (b) {
      b.addEventListener("click", function () {
        removeItem(this.dataset.cat, this.dataset.handle);
        if (state[this.dataset.cat].length === 0) { close(); }
        else { openOverlay(this.dataset.cat); }
      });
    });
    document.addEventListener("keydown", function onEsc(e) {
      if (e.key === "Escape") { close(); document.removeEventListener("keydown", onEsc); }
    });
  }

  function initToggle() {
    var btn = document.getElementById("fs-compare-toggle");
    if (!btn) return;
    btn.addEventListener("click", function () {
      var prod = readProductFromDom();
      if (!prod) return;
      if (inList(prod.cat, prod.handle)) {
        removeItem(prod.cat, prod.handle);
      } else {
        var res = addItem(prod.cat, prod);
        if (!res.ok && res.msg) toast(res.msg);
      }
    });
  }

  function toast(msg) {
    if (!msg) return;
    var t = document.getElementById("fs-compare-toast");
    if (!t) {
      t = document.createElement("div");
      t.id = "fs-compare-toast";
      t.className = "fs-compare-toast";
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add("is-show");
    setTimeout(function () { t.classList.remove("is-show"); }, 2200);
  }

  function readCardData(el) {
    var d = el.dataset;
    if (!d.handle || !d.cat || !CATS[d.cat]) return null;
    return {
      handle: d.handle, cat: d.cat, title: d.title || "",
      url: d.url || ("/products/" + d.handle), image: d.image || "",
      price: d.price || "", tempo: d.tempo || "", kontrolle: d.kontrolle || "",
      elastizitaet: d.elast || "", haerte: d.haerte || "",
      schwammhaerte: d.schwammhaerte || "",
      schwamm: d.schwamm || "", holztyp: d.holztyp || "", eignung: d.eignung || "",
      gewicht: d.gewicht || ""
    };
  }

  function makeCardButton(prod) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "fs-card-compare-btn";
    btn.setAttribute("data-fs-handle", prod.handle);
    btn.setAttribute("data-fs-cat", prod.cat);
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (inList(prod.cat, prod.handle)) {
        removeItem(prod.cat, prod.handle);
      } else {
        var res = addItem(prod.cat, prod);
        if (!res.ok && res.msg) toast(res.msg);
      }
    });
    return btn;
  }

  function syncCardButtons() {
    document.querySelectorAll(".fs-card-compare-btn").forEach(function (btn) {
      var cat = btn.getAttribute("data-fs-cat");
      var handle = btn.getAttribute("data-fs-handle");
      if (inList(cat, handle)) {
        btn.classList.add("is-added");
        btn.textContent = "Im Vergleich \u2713";
      } else {
        btn.classList.remove("is-added");
        btn.textContent = "+ Vergleich";
      }
    });
  }

  function initCards() {
    var datas = document.querySelectorAll(".fs-card-data");
    if (!datas.length) return;
    datas.forEach(function (el) {
      var prod = readCardData(el);
      if (!prod) return;
      var card = el.closest("product-card") || el.parentElement;
      if (!card) return;
      if (card.querySelector(".fs-card-compare-btn")) return;
      var btn = makeCardButton(prod);
      var content = card.querySelector(".product-card__content") || card;
      content.appendChild(btn);
    });
    syncCardButtons();
  }

  function init() { initToggle(); initCards(); render(); }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
